import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledRiskObjectCard = styled.div<{ $isSelected: boolean }>`
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    height: 112px;
    padding: 10px;
    cursor: pointer;
    background-color: var(--color-white);
    border-radius: var(--radius-10);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);

    @media ${breakpoints.xs} {
        width: 100%;
        margin-right: 0;
    }

    .categoryIcon {
        position: absolute;
        right: 0;
        bottom: 0;
        min-width: 24px;
    }

    .riskObjectCardInfo {
        width: 78%;
    }

    .typeName {
        font-size: var(--size-16);
        font-style: normal;
        font-weight: bold;
        line-height: 24px;
        color: var(--color-secondary);
    }

    .riskObjectName {
        display: -webkit-box;
        margin-bottom: 4px;
        overflow: hidden;
        font-size: var(--size-14);
        font-style: normal;
        font-weight: normal;
        line-height: 20px;
        color: var(--color-grey-900);
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-clamp: 2;
    }

    .policyholderName {
        display: -webkit-box;
        overflow: hidden;
        font-size: var(--size-14);
        font-style: normal;
        font-weight: normal;
        line-height: 20px;
        color: var(--color-grey-900);
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        line-clamp: 1;
    }

    ${(props) =>
        props.$isSelected &&
        `
        position: relative;
        background-color: var(--color-selected) !important;
        .checkIcon {
            position: absolute;
            top: 16px;
            right: 16px;
            width: 18px;
        }
  `}
`;
